/**
 * PDF.js / react-pdf-highlighter често мењају димензије у ResizeObserver колбеку истог фрејма.
 * Chromium тада понекад баца "ResizeObserver loop completed..." — то није баг приложба.
 * Одлагање колбека за један animation frame типично уклања узрок.
 */
/* eslint-disable max-classes-per-file */

if (typeof window !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;
  const flag = '__ogpResizeObserverRafDefer';
  if (OriginalResizeObserver && !window[flag]) {
    window[flag] = true;
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            callback(entries, observer);
          });
        });
      }
    };
  }
}
